import { render, staticRenderFns } from "./Schools.vue?vue&type=template&id=2f57e362&scoped=true&lang=pug"
import script from "./Schools.vue?vue&type=script&lang=js"
export * from "./Schools.vue?vue&type=script&lang=js"
import style0 from "./Schools.vue?vue&type=style&index=0&id=2f57e362&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f57e362",
  null
  
)

export default component.exports